export default __webpack_public_path__ + "static/media/lose.46399869.png";